import { CreditCardType } from './credit-card-type';

export interface CreditCardDetails {
  cardType: CreditCardType;
  holderName: string;
  number: string;
  maskedNumber: string;
  cvc: string;
  expiry: string;
  expiryMonth: number;
  expiryYear: number;
  encryptedString: string;
}
